module.exports = __webpack_public_path__ + "static/media/level-5-anim.b041e8d1.gif";